import { createElement } from 'react';

const TELEFONE_REGEX = /(?:(?:(\d{2})?(\d{2})?((?:9 \d{4}[-.][\d]{4})|(?:\d{4}[-.]\d{4})|(?:(?:\d{3}[-.]){2}\d{3})|9\d{8}|\d{8})\b)|(?:(?:(?:\+(\d{1,3})(\d{2,3}))|(?:(55)(\d{2,3})))(9\d{8}|[1-8]\d{7})|(?:(?:\+(\d{1,3})|(\d{1,3}))[ (]+(\d{2,3})\b[ )]+((?:9 \d{4}[-.][\d]{4})|(?:\d{4}[-.]\d{4})|(?:(?:\d{3}[-.]){2}\d{3})|9\d{8}|\d{8})))|(?:(?:(\d{2,3}))(9\d{8}|[1-8]\d{7})|(?:\(?(\d{2,3})\b[ )]+((?:9 \d{4}[-.][\d]{4})|(?:\d{4,5}[-.]\d{4})|(?:(?:\d{3}[-.]){2}\d{3})|9\d{8}|\d{8}))))/;

const telefone = (ddi, ddd, numero) => {
  if (typeof numero === "string") {
    let found = numero.match(TELEFONE_REGEX);

    if (!found) {
      return { ddi, ddd, numero };
    }

    let indexes;
    if (found[1]) {
      indexes = found[2]?[3, 2, 1]:[3, 1];
    } else if (found[3]) {
      indexes = [3];
    } else if (found[4]) {
      indexes = [8, 5, 4];
    } else if (found[6]) {
      indexes = [8, 7, 6];
    } else if (found[9]) {
      indexes = [12, 11, 9];
    } else if (found[10]) {
      indexes = [12, 11, 10];
    } else if (found[13]) {
      indexes = [14, 13];
    } else if (found[15]) {
      indexes = [16, 15];
    }

    return {
      ddi: found[indexes[2]] || ddi,
      ddd: found[indexes[1]] || ddd,
      numero: found[indexes[0]]
    };
  }

  return {
    ddi,
    ddd,
    ...numero
  };
};

export const tel2str = (value, mask = "+{DDI} ({DDD}) {NUMBER}") => mask.replace(/\{(\w+)\}/g, (_$0, $1) => {
  if ('NUMBER' === $1) {
    return (value.numero.length % 3?value.numero.replace(/\d(?=(?:\d{4})+(?:\D|$))/g, "$&-"):value.numero.replace(/\d(?=(?:\d{3})+(?:\D|$))/g, "$&-"));
  }
  return value[$1.toLowerCase()];
});

export default ({children, ddi = 55, ddd = 83, tag = "a", mask, ...otherProps}) => {
  const tel = telefone(ddi, ddd, children);

  return createElement(tag, {
    ...otherProps,
    href: "tel:+" + tel.ddi + tel.ddd + tel.numero
  }, tel2str(tel, mask))
};


// WEBPACK FOOTER //
// ./src/components/Telefone.js